import API from './api';

const hrChatService = {
  /**
   * Send a chat message, optionally with images (base64).
   * @param {string} message - Text message
   * @param {Array} conversationHistory - Previous messages
   * @param {Array<{base64: string, mimeType: string, name: string}>} images - Optional images
   */
  async sendMessage(message, conversationHistory = [], images = [], options = {}) {
    const payload = {
      message,
      conversationHistory,
    };

    if (images && images.length > 0) {
      payload.images = images.map(img => ({
        base64: img.base64,
        mimeType: img.mimeType,
        name: img.name,
      }));
    }

    if (options?.rawMode === true) {
      payload.rawMode = true;
    }

    const requestConfig = {
      timeout: 300000,
      ...(options?.signal ? { signal: options.signal } : {})
    };

    const response = await API.post('/ai/hr-chat', payload, requestConfig);
    return response.data;
  },

  async getPersonalBrief() {
    const response = await API.get('/ai/personal-brief', { timeout: 45000 });
    return response.data;
  }
};

export default hrChatService;
